
<template>
    <div class="sales">
      <div class="content">
        <div>
          <distribution :sales_data='sales_data'></distribution>
          <distribution-ranking :sales_data='sales_data'></distribution-ranking>
          <div style="clear:both;"></div>
        </div>
        <sales-trend></sales-trend>
        <sales-table></sales-table>
    </div>
  </div>


</template>

<script>
import axios from 'axios'
import distribution from '../sales/sales-distribution'
import distribution_ranking from '../sales/sales-distribution-ranking'
import sales_trend from '../sales/sales-trend'
import sales_table from '../sales/sales-table'

export default {
  data() {
    return {
      sales_data: [{
          name: '北京',
          value: this.randomValue()
        },
        {
          name: '天津',
          value: this.randomValue()
        },
        {
          name: '上海',
          value: this.randomValue()
        },
        {
          name: '重庆',
          value: this.randomValue()
        },
        {
          name: '河北',
          value: this.randomValue()
        },
        {
          name: '河南',
          value: this.randomValue()
        },
        {
          name: '云南',
          value: this.randomValue()
        },
        {
          name: '辽宁',
          value: this.randomValue()
        },
        {
          name: '黑龙江',
          value: this.randomValue()
        },
        {
          name: '湖南',
          value: this.randomValue()
        },
        {
          name: '安徽',
          value: this.randomValue()
        },
        {
          name: '山东',
          value: this.randomValue()
        },
        {
          name: '新疆',
          value: this.randomValue()
        },
        {
          name: '江苏',
          value: this.randomValue()
        },
        {
          name: '浙江',
          value: this.randomValue()
        },
        {
          name: '江西',
          value: this.randomValue()
        },
        {
          name: '湖北',
          value: this.randomValue()
        },
        {
          name: '广西',
          value: this.randomValue()
        },
        {
          name: '甘肃',
          value: this.randomValue()
        },
        {
          name: '山西',
          value: this.randomValue()
        },
        {
          name: '内蒙古',
          value: this.randomValue()
        },
        {
          name: '陕西',
          value: this.randomValue()
        },
        {
          name: '吉林',
          value: this.randomValue()
        },
        {
          name: '福建',
          value: this.randomValue()
        },
        {
          name: '贵州',
          value: this.randomValue()
        },
        {
          name: '广东',
          value: this.randomValue()
        },
        {
          name: '青海',
          value: this.randomValue()
        },
        {
          name: '西藏',
          value: this.randomValue()
        },
        {
          name: '四川',
          value: this.randomValue()
        },
        {
          name: '宁夏',
          value: this.randomValue()
        },
        {
          name: '海南',
          value: this.randomValue()
        },
        {
          name: '台湾',
          value: this.randomValue()
        },
        {
          name: '香港',
          value: this.randomValue()
        },
        {
          name: '澳门',
          value: this.randomValue()
        }
      ]
    }
  },
  methods: {
    randomValue() {
      return Math.round(Math.random() * 1500)
    },
  },
  components: {
    'distribution': distribution,
    'distribution-ranking': distribution_ranking,
    'sales-trend': sales_trend,
    'sales-table': sales_table
  }
}
</script>

<style scoped lang="scss">
.sales {
  padding: 30px;
  background-color: #F8F9FB;
  .content {
    width: 1200px;
    margin: 0px auto;

    .sales-trend {
      background-color: #fff;
      margin-top: 20px;
    }


  }
  .content:first-child {
    width: 1200px;
    background-color: #fff;
    .sales-distribution {
      float: left;
      margin-left: 50px;
    }
    .sales-distribution-ranking {
      float: right;
      margin-right: 50px;
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/views/index/data-analysis/sales/sales.vue